import Modal from 'react-modal'
import './login-modal.css';
import agent from '../agent';
import React from 'react';
import SGIDPromptModal from './SGIDPromptModal.js'
import { BACKEND_URL } from '../constants/constants';
import LoginFeedbackModal from './LoginFeedbackModal.js'

class EmailVerificationModal extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      showLoginPrompt: false,
      otp: '',
      isError: false,
      showMessage: false,
      message: 'OTP Sent',
      email: '',
      handle: '',
      password: '' 
    }
  }

  openLoginPrompt = (email, password, handle) => {
    this.setState({ email });
    this.setState({ password });
    this.setState({ handle });
    this.setState({ showLoginPrompt: true });
    this.resendOTP()
  }
  
  closeLoginPrompt = () => {
    this.setState({ showLoginPrompt: false });
  }

  handleOTPChange = (e) => {
    this.setState({ showMessage: false });
    this.setState({ otp: e.target.value });
    this.forceUpdate() 
  }

  verifyOTP = () => {
    agent.Profile.verify(this.state.otp, this.state.email, this.state.password).then((user) => {
      this.closeLoginPrompt()
      if (user.preferredName) {
        this.refs.loginFeedbackModal.openLoginFeedback(user.preferredName)
      } else {
        this.refs.SGIDPromptModal.openLoginPrompt(this.state.handle)
      }
    })
    .catch(error => {
      this.setState({ isError: true });
      this.setState({ showMessage: true });
      this.setState({ message: error.response.data });
      this.forceUpdate() 
    })
  }

  resendOTP = () => {
    agent.Profile.resend(this.state.email).then((response) => {
      this.setState({ isError: false });
      this.setState({ showMessage: true });
      this.setState({ message: response.message });
      this.forceUpdate() 
    })
    .catch(error => {
      console.log('otp sending failure', error)
    })
  }

  openLoginModal = (event) => {
    if (event) event.preventDefault()
    this.closeLoginPrompt()
    let container = this.props.container
    container.openLoginModal()
  }

  getMessageStyling = () => {
    if (this.state.showMessage) {
      if (this.state.isError) {
        return { 
          visibility: 'visible',
          color: '#CC4747'
        }
      } else {
        return { 
          visibility: 'visible',
          color: 'rgb(73, 76, 162)'
        }
      }
    } else {
      return { 
        visibility: "hidden" 
      }
    }
  }

  render() {
    return (
      <div>
        <Modal
          isOpen={this.state.showLoginPrompt}
          onRequestClose={this.closeLoginPrompt}
          className="login-modal"
          overlayClassName="Overlay">
          <img src={`${BACKEND_URL}/assets/logo-grey.png`}></img>
          <div className="title">Key in the 6 digit One-Time Password (OTP) sent to your email address</div>
          <input className="otp" autoFocus onChange={this.handleOTPChange} maxLength="6"></input>
          <div className="message" style={this.getMessageStyling()}>{ this.state.message }</div>
          <div className="verify" onClick={this.verifyOTP}>
            Verify
          </div>
          <div className="resend" onClick={this.resendOTP}>Resend OTP?</div>
          <div className="cancel-container">
            <div className="cancel-prompt">Already a member?</div>
            <a className="cancel-btn" onClick={ this.openLoginModal }>Log in here.</a>
          </div>
        </Modal>
        <SGIDPromptModal container={this} ref="SGIDPromptModal"/>
        <LoginFeedbackModal container={this} ref="loginFeedbackModal"/>
      </div>
    ); 
  }
}

export default EmailVerificationModal


// WEBPACK FOOTER //
// ./src/components/EmailVerificationModal.js